export default __webpack_public_path__ + "static/media/menuRenomear.bff7c1e4.svg";